// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CenteredDiv-cls1___99a0cd510b239d4a078{/*!*/}.CenteredDiv-cls2___d835da1742b5620a899{display:inline-block;margin:auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "CenteredDiv-cls1___99a0cd510b239d4a078",
	"cls2": "CenteredDiv-cls2___d835da1742b5620a899 CenteredDiv-cls1___99a0cd510b239d4a078"
};
export default ___CSS_LOADER_EXPORT___;
